import React from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { GlobalViewTaxForm } from './global-viewtaxform';
import { ViewTaxFormPropTypes } from '../../shapes';

const { CountryCode } = Constants;

export const WFTaxViewTaxForm = props => (
  <GlobalViewTaxForm
    {...props}
    countryCode={CountryCode.WF}
    showTaxCert={false}
  />
);

WFTaxViewTaxForm.propTypes = ViewTaxFormPropTypes;
